<template>
  <div class="leftBar">
    <v-drawer :direction="'right'" :width="'26%'">
      <div class="animated fadeInRightBig dx">
        <bar-card class="lefts lefts1" :bg="'border-new'">
          <g-title :bg="'zxqc'">种畜禽场情况</g-title>
          <div class="panelContent">
            <right-cp />
          </div>
        </bar-card>
        <bar-card class="lefts lefts2" :bg="'border-new'">
          <g-title :bg="'sygm'">饲养规模情况</g-title>
          <div class="panelContent">
            <right-xm />
          </div>
        </bar-card>
        <bar-card class="lefts" :bg="'border-new'">
          <g-title :bg="'syqk'">饲料生产情况</g-title>
          <!-- <g-title :bg="'syqk'">主要年份饲养生产情况</g-title> -->
          <div class="panelContent">
            <right-yz />
          </div>
        </bar-card>
      </div>
    </v-drawer>
  </div>
</template>

<script>
import rightCp from "./rightBar/rightCp";
import rightXm from "./rightBar/rightXm";
import rightYz from "./rightBar/rightYz";
import gTitle from "../components/gTitle";
export default {
  components: { rightCp, rightXm, rightYz, gTitle },
  data() {
    return {};
  }
};
</script>

//
<style lang="stylus" scoped>
// @media (min-height 1400px)
//   .rightBar
//     >>>.side
//       width 24% !important
//
</style>

<style lang="stylus" scoped>
.dx
  height 100%
.panelContent
  height calc(100% - 39px)
  color #fff
.lefts
  margin-bottom 10px
  // height calc(28.33% - 10px)
  height calc(32% - 10px)
.lefts1
  // height calc(38.33% - 10px)
  height calc(36% - 10px)
.lefts2
  // height calc(33.33% - 10px)
  height calc(32% - 10px)
.leftBar
  >>>.side
    bottom 8px
@media (min-height 1400px)
  .leftBar
    >>>.side
      width 24% !important
</style>
